module.exports = __webpack_public_path__ + "assets/img/dzh-19.af8e557e.jpg";